import React, { useEffect } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';

import { Bus, get, getAvailablePages, SiteConfigManager } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';

import IFrameBetHistory from './IFrameBetHistory';

const availableGeneralRoutes = {
  [COMPONENT_TYPES.SPORT_LIVE]: {},
  [COMPONENT_TYPES.SPORT_PREMATCH]: {},
  [COMPONENT_TYPES.RESULTS]: {},
};

const IFrameRouter = () => {
  const routes = getAvailablePages(
    availableGeneralRoutes,
    SiteConfigManager.getExtraConfig('components'),
  );

  const routeToRedirect = get(routes, '0.path');

  const location = useLocation();
  useEffect(() => {
    Bus.emit('router:change_location', location);
  }, [location.pathname, location.search, location.hash]);

  return (
    <Switch>
      <Route component={IFrameBetHistory} path="/bet-history" />

      {routes.map(route => (
        <Route component={route.component} key={route.type} path={route.path} />
      ))}

      {routeToRedirect && <Redirect to={`${routeToRedirect}${location.search}`} />}
    </Switch>
  );
};

export default IFrameRouter;
